import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useFiltersContainerStyles = makeStyles((theme: Theme) => ({
	filterCounter: {
		alignItems: 'center',
		backgroundColor: theme.palette.info.main,
		borderRadius: '50%',
		color: 'white',
		display: 'flex',
		fontSize: '12px !important',
		height: 18,
		justifyContent: 'center',
		width: 18,
	},
	button: {
		color: '#5B5B5B !important',
		fontWeight: 'bold !important',
	},
	buttonNull: {
		padding: '0 !important',
		minWidth: '55px !important',
	},
}));

export default useFiltersContainerStyles;
